import { useRouter } from "next/router";
import { useMemo } from "react";

import userAtom from "@/atoms/userAtom";
import { Loader } from "@/components/shared/ui/Loader";
import useReviewerDecisions from "@/hooks/methodology/useReviewerDecisions";
import { UserRole } from "@/types/Role";
import { useAtom } from "jotai";
import ReviewerDecisionCard from "../ReviewerDecisionCard";

const Decisions = ({ methodologyStatus }: { methodologyStatus?: string }) => {
	const router = useRouter();
	const methodologyId = parseInt(router.query.id as string);
	const roundId = parseInt(router.query.roundId as string);

	if (methodologyId && roundId)
		return <DecisionsTab methodologyId={methodologyId} roundId={roundId} methodologyStatus={methodologyStatus} />;

	return <p>N/A</p>;
};

export default Decisions;

export const DecisionsTab = ({
	methodologyId,
	roundId,
	methodologyStatus,
}: {
	methodologyId: number;
	roundId: number;
	methodologyStatus?: string;
}) => {
	const { data: decisions, isLoading, isError } = useReviewerDecisions({ methodologyId, roundId });

	//TODO: Is this necessary?
	const lastRoundDecisions = useMemo(() => decisions?.[0] ?? undefined, [decisions]);

	const [user] = useAtom(userAtom);

	const { contributors, experts } = useMemo(() => {
		const contributors = lastRoundDecisions?.reviewerDetail.filter((x) => x.nonVoting);
		const experts = lastRoundDecisions?.reviewerDetail.filter((x) => !x.nonVoting);

		return {
			contributors,
			experts,
		};
	}, [lastRoundDecisions]);

	// as of now , we'll let the user click reviewer card if the user is admin
	// or else if the mtd status is approved
	const reviewerCardClickEnabled = user?.roles?.includes(UserRole.ADMIN) || methodologyStatus == "APPROVED";

	if (isLoading) return <Loader />;
	if (isError) return <div>Something went wrong</div>;

	return (
		<div className="space-y-8">
			<div>
				<h3>Expert Panel</h3>
				<div className="flex flex-wrap">
					{experts &&
						experts.map((reviewer) => (
							<ReviewerDecisionCard
								key={`expert-${reviewer.name} - ${reviewer.organization}`}
								reviewer={reviewer}
								isClickable={reviewerCardClickEnabled}
							/>
						))}
				</div>
			</div>
			<div>
				<h3>Contributors</h3>
				<div className="flex flex-wrap">
					{contributors &&
						contributors.map((reviewer) => (
							<ReviewerDecisionCard
								key={`contributor-${reviewer.name} - ${reviewer.organization}`}
								reviewer={reviewer}
								isClickable={reviewerCardClickEnabled}
							/>
						))}
				</div>
			</div>
		</div>
	);
};
